module.exports = __webpack_public_path__ + "img/download.ce358879.svg";